import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

// The admin's working season and week live in the URL (?season=2026&week=5),
// so they survive a refresh and carry across the admin tabs: the week picked
// on Games is the week Scoring opens on. This is the *working* week; the week
// players see is a separate value (games/{season}.currentWeek) that admins set
// explicitly with "Set as active".
// The week pickers offer 1..MAX_WEEK; anything else in the URL is ignored
// rather than becoming a working week no control can show.
export const MAX_WEEK = 20;

const parseWeek = (value) => {
  const n = parseInt(value, 10);
  return Number.isInteger(n) && n >= 1 && n <= MAX_WEEK ? n : null;
};

export default function useAdminWeek() {
  const [params, setParams] = useSearchParams();
  const season = params.get('season') || null;
  const week = parseWeek(params.get('week'));

  const update = useCallback((changes) => {
    setParams((prev) => {
      const next = new URLSearchParams(prev);
      Object.entries(changes).forEach(([key, value]) => {
        if (value === null || value === undefined || value === '') next.delete(key);
        else next.set(key, String(value));
      });
      return next;
    }, { replace: true });
  }, [setParams]);

  return useMemo(() => ({
    season,
    week,
    setSeason: (nextSeason) => update({ season: nextSeason }),
    setWeek: (nextWeek) => update({ week: nextWeek }),
    setSelection: (nextSeason, nextWeek) => update({ season: nextSeason, week: nextWeek }),
  }), [season, week, update]);
}
